// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"856c12cb","481":"df6556c1","648":"c6e4a678"}[chunkId] + ".chunk.css";
};